/**
 * 主要提供给内嵌
 * @author lianghua.fu
 * @date 2022-04-25 22:19:19
 */
import { vcToastMsg } from 'client/pc/func/user-wish/service';
import { UiModal } from 'components';
import qs from 'query-string';
import config from './config';
import { getUrl, redirectUrl } from './base';
import user from './user';
// import games from 'widgets/functions/games';
import games from '../modules/widgets/functions/games';
import messenger from './messenger';
import { store as actStore } from 'client/widgets/functions/activity/store';
import { create } from 'lib/debug';

const log = create('publicApi');

// 打开新人任务
// const showUserTasksPopup = ({ id }) => {
//   UiModal.iframe({
//     url: `https://${config.domain.h5}/app/new-user-task?id=${id}`,
//     // url: `http://localhost.2339.com:9200/app/new-user-task?id=${id}`,
//     maskOpacity: 0.1,
//     width: 440,
//     height: 648,
//   });
// };

// 播放器静音
const setMuted = (isMuted) => {
  document.querySelectorAll('#j_playerContainer video').forEach((item) => {
    (item as HTMLVideoElement).muted = isMuted;
  });
};

// todo 可以扩展下其他游戏
const showGame = (gameKey) => {
  // if (gameKey === 'starWish') {
  //   MM.live.game.h5StarWish.show();
  // }
  games.showGame(gameKey);
};

const updateActList = (list) => {
  log('updateActList', list);
  actStore.updateList(list.filter((item) => !(item.hideInEntry || item.hideInTab)));
};

const all = {
  // getToken: user.getToken, // messenger.parentActions 中已包含
  setMuted,
  showGame,
  UiModal,
  // 这里的对外的统一到messenger action
  ...messenger.parentActions,
  ...messenger.actions,
  redirectUrl,
  updateActList,
  vcToastMsg,
};

if (typeof window !== 'undefined') {
  window.wwwPublic = all;
}

export default all;
